<template>
  <div class="container-fluid p-5" style="margin-top: 50px; margin-bottom: 80px">
    <TableHeader title="Mis Semillas" buttonText="CREAR SEMILLA" routeName="create-seed" />

    <div class="d-flex justify-content-between pb-1 gap-2 w-25" style="border: 2px solid black; border-radius: 5px 5px 0 0; padding: 5px; background: black">
      <n-input placeholder="Buscar semillas" v-model:value="searchBar" @keyup.enter="this.getSeeds(this.searchBar)">
        <template #suffix>
          <i class="icon-remove-circle input-icon" @click="this.cleanSearch"></i>
        </template>
      </n-input>
      <n-button secondary type="info" @click="this.getSeeds(this.searchBar)" style="background: white">Buscar </n-button>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-head-dark">
          <tr>
            <th scope="col" class="text-center" @click="this.sortColumn('product')" style="width: 5%">
              Producto
              <i v-if="this.selectedColumn === 'product'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-center" @click="this.sortColumn('name')" style="width: 5%">
              Nombre
              <i v-if="this.selectedColumn === 'name'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-center" style="width: 2%">Tipo</th>
            <th scope="col" class="text-center" @click="this.sortColumn('provider')" style="width: 5%">
              Proveedor
              <i v-if="this.selectedColumn === 'provider'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-center" style="width: 5%">Estación</th>
            <th scope="col" class="text-center" style="width: 12%">Gasoil</th>
            <th scope="col" class="text-center" style="width: 3%">Suministros</th>
            <th scope="col" class="text-center" style="width: 10%; font-size: 13px">Performance por hectarea</th>
            <th scope="col" class="text-center" style="width: 4%; font-size: 13px">Boost de productividad</th>
            <th scope="col" class="text-center" style="width: 6%; font-size: 13px">Precios por bolsa</th>
            <th scope="col" class="text-center" style="width: 8%; font-size: 14px">Cantidad por bolsa</th>
            <th scope="col" class="text-center" style="width: 10%; font-size: 13px">Cantidad de bolsas por hectarea</th>
            <th scope="col" class="text-center" style="width: 10%; font-size: 13px">Estado</th>
            <th scope="col" class="text-center" style="width: 8%">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr scope="row" v-if="this.loading" style="width: 50vw; height: 2rem">
            <td colspan="14">
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </td>
          </tr>
          <tr scope="row" v-else-if="!this.loading && this.seeds.length === 0" style="width: 50vw; height: 2rem">
            <td colspan="14" class="text-center">
              <n-p>No se encontraron resultados...</n-p>
            </td>
          </tr>
          <tr v-else-if="!this.loading && this.seeds.length > 0" v-for="(seed, index) in this.seeds" :key="index">
            <td scope="row" class="align-middle text-center">{{ seed.product?.name ? seed.product?.name : "No especificado" }}</td>
            <td scope="row" class="align-middle text-center">{{ seed?.name }}</td>
            <td scope="row" class="align-middle text-center">{{ seed.type ? seed.type : "No especificado" }}</td>
            <td scope="row" class="align-middle text-center">{{ seed.provider?.name }}</td>
            <td scope="row" class="align-middle text-center">
              {{ seed.season.winter ? "Invierno" : null }}
              {{ seed.season.winter && seed.season.summer ? "y" : null }}
              {{ seed.season.summer ? "Verano" : null }}
            </td>
            <td scope="row" class="align-middle text-center">
              Recomendado: {{ seed.gasoil.recommended }}
              <br />
              Minimo: {{ seed.gasoil.min ? seed.gasoil.min : "-" }}
              <br />
              Maximo: {{ seed.gasoil.max ? seed.gasoil.max : "-" }}
            </td>
            <td scope="row" class="align-middle text-center">
              <n-button type="info" @click="suppliesModal(seed)"> VER </n-button>
            </td>
            <td scope="row" class="align-middle text-center">
              Estimado: {{ seed.performancePerHectare.estimate ? seed.performancePerHectare.estimate : "-" }}
              <br />
              Minimo: {{ seed.performancePerHectare.min ? seed.performancePerHectare.min : "-" }}
              <br />
              Maximo: {{ seed.performancePerHectare.max ? seed.performancePerHectare.max : "-" }}
            </td>
            <td scope="row" class="align-middle text-center">
              {{ seed.productivityBoost.min }}
              {{ seed.productivityBoost.min != null && seed.productivityBoost.max != null ? "-" : null }}
              {{ seed.productivityBoost.max }}
              {{ seed.productivityBoost.min != null || seed.productivityBoost.max != null ? "%" : "No especificado" }}
            </td>
            <td scope="row" class="align-middle text-center">
              <n-button type="info" @click="pricePerBagModal(seed)"> VER </n-button>
            </td>
            <td scope="row" class="align-middle text-center">
              {{ seed.amountPerBag?.kg ? seed.amountPerBag?.kg : seed.amountPerBag?.seeds }}
              {{ seed.amountPerBag?.kg ? "KG" : "" }}
              {{ seed.amountPerBag?.seeds ? "Semillas" : "" }}
            </td>
            <td scope="row" class="align-middle text-center">
              Estimado: {{ seed.bagsPerHectare.recommended ? seed.bagsPerHectare.recommended : "-" }}
              <br />
              Minimo: {{ seed.bagsPerHectare.min ? seed.bagsPerHectare.min : "-" }}
              <br />
              Maximo: {{ seed.bagsPerHectare.max ? seed.bagsPerHectare.max : "-" }}
            </td>
            <td scope="row" class="align-middle text-center">{{ seed.isAvailable ? "Disponible" : "No disponible" }}</td>
            <td scope="row" class="align-middle text-center">
              <n-tooltip trigger="hover">
                <template #trigger>
                  <router-link :to="{ name: 'edit-seed-supply', params: { id: seed._id } }" style="text-decoration: none; color: inherit">
                    <i class="icon-edit" style="padding-right: 12px" />
                  </router-link>
                </template>
                Editar
              </n-tooltip>
              <n-tooltip trigger="hover">
                <template #trigger>
                  <i class="icon-copy" style="padding-right: 12px; cursor: pointer" @click="cloneSeed(seed)" />
                </template>
                Clonar
              </n-tooltip>
              <n-tooltip trigger="hover">
                <template #trigger>
                  <span @click="handleConfirm(seed)" style="cursor: pointer; padding-bottom: 4px; padding-right: 12px">
                    <i class="icon-trash" />
                  </span>
                </template>
                Eliminar
              </n-tooltip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-around pb-1 g-2 mt-2" v-if="!this.loading && this.seeds.length !== 0">
      <n-button type="info" size="medium" style="font-size: 20px" @click="this.goToPreviousPage" v-show="this.page > 1"> &lt; Pagina anterior </n-button>
      <span type="info" size="medium" style="font-size: 20px" v-show="this.page - 1 === 0"> </span>
      <n-p>Página {{ this.page }} de {{ this.numberOfPages }}</n-p>
      <n-button type="info" quaternary size="medium" style="font-size: 20px" @click="this.goToNextPage" :disabled="this.seeds.length < 25">
        Pagina siguiente &gt;
      </n-button>
    </div>
  </div>
  <n-modal v-model:show="showSuppliesModal">
    <n-card style="width: 1000px" title="Suministros" :bordered="false" size="huge" role="dialog" aria-modal="true">
      <template #header-extra> Semilla: {{ this.selectedSeed.name }} </template>
      <n-table :bordered="false" :single-line="false">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Nombre</th>
            <th>Dosis recomendada</th>
            <th>Dosis minima</th>
            <th>Dosis maxima</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(supplyData, index) in this.selectedSeed.supplies" :key="index">
            <td>{{ supplyData.supply.type ? translateType(supplyData.supply.type) : "Tipo no encontrado" }}</td>
            <td>{{ supplyData.supply.name }}</td>
            <td>{{ supplyData.dose.recommended }}</td>
            <td>{{ supplyData.dose.min }}</td>
            <td>{{ supplyData.dose.max }}</td>
          </tr>
        </tbody>
      </n-table>
    </n-card>
  </n-modal>
  <n-modal v-model:show="showPricePerBagModal">
    <n-card style="width: 600px" title="Precios por bolsa" :bordered="false" size="huge" role="dialog" aria-modal="true">
      <template #header-extra> Semilla: {{ this.selectedSeed.name }} </template>
      <n-table :bordered="false" :single-line="false">
        <thead>
          <tr>
            <th>Desde X</th>
            <th>Hasta X</th>
            <th>Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(priceRange, index) in this.selectedSeed.pricePerBag" :key="index">
            <td>{{ priceRange.from }}</td>
            <td>{{ priceRange.to }}</td>
            <td>{{ priceRange.price }}</td>
          </tr>
        </tbody>
      </n-table>
    </n-card>
  </n-modal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage, useDialog } from "naive-ui";
import authStore from "../../store/auth.js";
import productStore from "../../store/product";
import seedStore from "../../store/seed";
import TableHeader from "../../components/tableHeader.vue";

export default {
  data() {
    return {
      message: useMessage(),
      dialog: useDialog(),
      showExtraModal: false,
      selectedColumn: "",
      searchBar: "",
      selectedSeed: null,
      showSuppliesModal: false,
      showPricePerBagModal: false,
    };
  },
  computed: {
    ...mapState(authStore, ["isLoggedIn"]),
    ...mapState(productStore, ["product"]),
    ...mapState(seedStore, ["seeds", "page", "numberOfPages", "selectedColumn", "sortDirection", "loading"]),
  },
  methods: {
    ...mapActions(seedStore, ["removeSeed", "updateSeed", "getSeeds", "sortSeeds", "createSeed"]),
    ...mapActions(productStore, ["getProductsById"]),
    async cloneSeed(seed) {
      try {
        const {
          amountPerBag,
          bagsPerHectare,
          format,
          gasoil,
          performancePerHectare,
          pricePerBag,
          product,
          productivityBoost,
          provider,
          season,
          supplies,
          type,
        } = seed;
        let data = {
          amountPerBag,
          bagsPerHectare,
          format,
          gasoil,
          performancePerHectare,
          pricePerBag,
          product,
          productivityBoost,
          provider,
          season,
          supplies,
          type,
          isAvailable: false,
          name: `${seed.name} (copia)`,
        };
        await this.createSeed(data);
        this.message.success("Semilla clonada exitosamente");
        await this.getSeeds();
      } catch (e) {
        throw e;
      }
    },
    async cleanSearch() {
      this.searchBar = "";
      await this.getSeeds();
    },
    translateType(type) {
      if (type == "additive") return "Aditivos";
      if (type == "fertilizer") return "Fertilizante";
      if (type == "fertilizerAndPhytosanitary") return "Fertilizante + Fitosanitarios";
      if (type == "phytosanitary") return "Fitosanitarios";
    },
    sortColumn(key) {
      this.sortSeeds(key);
      this.selectedColumn = key;
    },
    suppliesModal(seed) {
      this.selectedSeed = seed;
      this.showSuppliesModal = true;
    },
    pricePerBagModal(seed) {
      this.selectedSeed = seed;
      this.showPricePerBagModal = true;
    },
    handleConfirm(seed) {
      this.dialog.warning({
        title: "Confirmar",
        content: "Esta seguro que desea eliminar esta semilla?",
        positiveText: "ACEPTAR",
        negativeText: "CANCELAR",
        onPositiveClick: () => {
          this.deleteSeed(seed._id);
        },
        onNegativeClick: () => {
          this.message.info("Acción cancelada");
        },
      });
    },
    async deleteSeed(id) {
      await this.removeSeed(id);
    },
  },
  async mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
    await this.getSeeds();
  },
  components: { TableHeader },
};
</script>

<style scoped>
.list-border {
  border-bottom: 1px solid var(--black);
}

.row-collapse-color1 {
  background-color: var(--white);
}

.row-collapse-color2 {
  background-color: var(--white);
}

.table-head-dark {
  background-color: var(--black);
  color: var(--white);
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
}

.table-border {
  border: solid var(--black) 2px;
}
</style>
